<template>
  <v-box>
    <div>
      <div class="custom-container">
        <div class="custom-col custom-col-right">
          <form-edit-activity :form-type="DESIGN_FORM_TYPE"
                              :mode="mode"
                              ref="designForm"
                              :entity-id="entityId"
                              :show-footer-navbar="false"
                              :show-header="false"
                              @form-created="formCreated"
                              :custom-style-for-fluid-container="customStyleForFluidContainer"
          >
          </form-edit-activity>
        </div>
        <div
            class="custom-col custom-col-left ribbon"
            :class="{ 'ribbon-hidden': !ribbonOpen }">
          <b-container style="margin-top:15px">
            <!-- UPLOAD IMAGE BUTTON -->
            <b-row class="pb-0">
              <b-col cols="12" class="text-left">
                <FileUploadButton
                    data-test-path="image-upload-inspiration"
                    @file-selected="imageSelected"
                    class="d-block"
                    ref="imageUpload"
                />
              </b-col>
              <b-col cols="12" class="mt-0 mb-0">
                <hr style="height:2px;"/>
              </b-col>
            </b-row>

            <b-row class="pb-0">
              <b-col cols="12">
                <label class="mb-2 px-2 text-left font-weight-bold">
                  {{ $tr('ai-inspiration-create-new-design-buttons-group', 'Create New Design') }}
                </label>
              </b-col>

              <b-col cols="12" class="d-flex flex-wrap" style="padding-right: 10px; padding-left: 10px;">
                <b-col cols="6" v-for="option in aiModelsOptions" :key="option.value" class="p-1">
                  <b-button
                      :class="typeOfAiModel !== option.value ? 'selected-btn' : 'unselected-btn'"
                      @click="option.click(option.value)"
                      class="w-100"
                  >
                    {{ option.text }}
                  </b-button>
                </b-col>
              </b-col>
            </b-row>

            <b-row v-if="typeOfAiModel==='Text To Image'" class="pb-0">
              <b-col>
                <form class="mt-2 d-flex justify-content-start">
                  <div class="d-flex flex-column w-100">
                    <label class="mr-3 mb-1 px-2 text-left" style="font-weight: bold">{{
                        $tr('ai-product-generator-type-of-product', 'Type of Product:')
                      }}</label>
                    <b-button-group size="sm" class="mt-1" data-test-path="type-of-product">
                      <b-button
                          v-for="option in productOptions"
                          :key="option.value"
                          :class="typeOfProduct !== option.value ? 'selected-btn' : 'unselected-btn'"
                          @click="option.click(option.value)"
                          style="padding: 10px 20px"
                      >
                        {{ option.text }}
                      </b-button>
                    </b-button-group>
                  </div>
                </form>
              </b-col>
            </b-row>

            <!-- CHECKBOXES WITH TECHNIC HOME DECOR -->
            <b-row class="pb-0 d-flex flex-column justify-content-start mt-2"
                   v-if="typeOfAiModel==='Text To Image' && typeOfProduct === 'Home Decor'">
              <b-col>
                <label class="mr-3 mb-1 px-2 text-left" style="font-weight: bold">{{
                    $tr('ai-product-generator-style', 'Style:')
                  }}</label>
                <div class="text-left">
                  <b-form-group
                      :text="$tr('ai-generator-technic-text', 'Technic')"
                      v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="selectedTechnic"
                        :options="technicOptions"
                        :aria-describedby="ariaDescribedby"
                        name="radios-btn-default"
                        class="checkbox-group w-100 custom-radio-group"
                        buttons
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>

            <b-row class="pb-0 d-flex flex-column justify-content-start mt-2"
                   v-if="typeOfAiModel==='Text To Image' && typeOfProduct === 'Fashion'">
              <b-col>
                <label class="mr-3 px-2 mb-1 text-left" style="font-weight: bold">{{
                    $tr('ai-product-generator-style', 'Style:')
                  }}</label>
                <div class="text-left">
                  <b-form-group
                      :text="$tr('ai-generator-poses', 'Select poses')"
                      v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="selectedPose"
                        :options="fashionPosesOptions"
                        :aria-describedby="ariaDescribedby"
                        name="radios-btn-default"
                        class="checkbox-group w-100 custom-radio-group"
                        buttons
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="typeOfAiModel==='Text To Image' && typeOfProduct === 'Accessories'"
                   class="d-flex flex-column justify-content-start area-product mb-2 mt-3">
              <b-col>
                <div class="w-100 py-2" style="border-radius: 5px; background-color: #EDF4FC;">
                  <label class="mr-3 px-2 pb-1 mt-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-type-of-accessories', 'Type of accessories:')
                    }}</label>
                  <div class="d-flex justify-content-start px-2 mb-3">
                    <b-form-group class="w-100">
                      <b-form-select
                          v-model="accessories"
                          ref="accessoriesInput"
                          @change="accessoriesRefresh"
                          :options="accessoriesOptions">
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <label class="mr-3 px-2 pb-1 mt-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-target-gender', 'Target gender:')
                    }}</label>
                  <div class="d-flex justify-content-start px-2 mb-3">
                    <b-form-group class="w-100">
                      <b-form-select
                          v-model="accessoriesTargetGender"
                          ref="accessoriesTargetGenderInput"
                          @change="accessoriesTargetGenderRefresh"
                          :options="genderOptions">
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="d-flex flex-column justify-content-start mt-3 mb-3"
                   v-if="typeOfAiModel==='Sketch To Image'">
              <b-col class="d-flex justify-content-center align-items-center">
                <div :class="['upload-box', { 'no-border': imageSrc }]" @click="triggerFileUpload">
                  <input type="file" ref="fileInput" @change="handleFileChange" style="display: none;"/>

                  <div v-if="imageSrc">
                    <button v-if="imageSrc" @click.stop="clearImage" type="button"
                            aria-label="Close" class="close d-none d-sm-inline-block clear-btn"
                            style="pointer-events: auto;">
                      <span aria-hidden="true">×</span>
                    </button>
                    <img :src="imageSrc" alt="Uploaded Image" class="uploaded-image"/>
                  </div>
                  <div v-else>
                    {{ $tr('ai-product-upload-your-image', 'Upload your image') }}
                  </div>
                </div>
              </b-col>
            </b-row>

            <!-- TEXT AREA -->

            <b-row class="d-flex flex-column justify-content-start area-product mt-3 mb-2">
              <b-col>
                <div class="py-2"
                     style="border-radius: 5px; background-color: #EDF4FC;">
                  <label class="mr-3 px-2 pb-1 mt-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-product-description:', 'Product Description:')
                    }}</label>
                  <div class="d-flex justify-content-start px-2 mb-3">
                    <b-form-textarea
                        id="input"
                        style="max-width: 100%;"
                        v-model="input"
                        :placeholder="$tr('ai-product-generator-placeholder2', 'Describe product or pattern. Example: Polo Cotton T-shirt with White Collar; Blue flowers on green background, cartoon style')"
                        rows="4"
                        max-rows="6">
                    </b-form-textarea>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="noText" class="d-flex justify-content-center">
              <p class="text-danger mb-0">{{
                  $tr("AI-no-text", "The description is too short. Min 3 characters")
                }}</p>
            </b-row>

            <!--            <b-row v-if="generating" class="mt-3">-->
            <!--              <b-col>-->
            <!--                <h3>{{ $tr('takeWhile', 'This may take a while (Approx. 15-20s)') }}</h3>-->
            <!--              </b-col>-->
            <!--            </b-row>-->

            <b-row class="pt-1 pb-1" v-if="generating">
              <b-col cols="12" class="text-left">
                <span>
                  {{
                    $tr("generating.information.approx", "This may take a while (approx. 15-20s).")
                  }}
                  </span>
              </b-col>
            </b-row>

            <!-- GENERATE AND DOWNLOAD BUTTONS -->
            <b-row class="pt-2 pb-3">
              <b-col cols="12" class="text-left">
                <FooterButton
                    type="Generate"
                    data-test-path="generate-image-inspiration"
                    @generate="handleGenerate"
                    classOfButton="w-100"
                    class="p-0"
                    labelClass="d-inline pl-1"
                    variant="plm-success"
                    :disabled="isFooterButtonDisabled">
                </FooterButton>
              </b-col>
            </b-row>

            <!-- CREATE PRODUCT BUTTON -->
            <b-row :class="typeOfProduct === 'Fashion' || typeOfProduct === 'Home Decor' ?'pb-0':'pb-3'">
              <b-col cols="12" class="text-left">
                <b-button class="mr-1 w-100 custom-button" type="button" @click="createProduct"
                  data-test-path="create-product-from-inspiration"
                >
                  <font-awesome-icon icon="file-upload"/>
                  <label class="m-0" style="font-size: 0.9rem;">{{
                      $tr("inspiration-to-project-button", "Add This Inspiration to Project List")
                    }}</label>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div v-if="isMobile" class="ribbon-toggle-container">
          <button
              class="ribbon-toggle-button custom-button"
              @click="toggleRibbon">
            <font-awesome-icon icon="bars" class="fa-lg"></font-awesome-icon>
          </button>
        </div>
        <slot name="footer">
          <FooterNavbar class="custom-footer" data-test-path="entity-edit-form-footer">
            <CloseButton :disabled="generating || disableClose" @close="cancel"></CloseButton>
            <FooterButton
                v-if="mode === 'NEW' && (!inspirationFormConfig.restrictedWrite || permissions[inspirationFormConfig.effectivePermissionWrite])"
                type="Save"
                data-test-path="save-and-close-button"
                :disabled="!inspirationForm || generating || disableClose || !inspirationForm.canSubmit || saveInProgress"
                @save="saveAndClose"
                :long-size="true"
                :label=" mode === 'NEW' ? ADD_AND_CLOSE_LABEL : SAVE_AND_CLOSE_LABEL"
            >
              <template v-slot:icon>
                <font-awesome-layers>
                  <font-awesome-icon icon="caret-left" transform="shrink-0 left-7"/>
                  <font-awesome-icon icon="save" transform="shrink-0 right-5 down-0"/>
                </font-awesome-layers>
              </template>
            </FooterButton>
          </FooterNavbar>
        </slot>
      </div>
    </div>
  </v-box>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Rpc from "@/Rpc";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";

import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";
import Product from "@/server/com/silkplm/model/plm/Product";
import DialogManager from "@/utils/DialogManager";
import _ from "lodash";
import {sortDynamicAttributes} from "@/components/cacheManager/DynamicAttributesSorter";
import Inspiration from "@/server/com/silkplm/model/plm/Inspiration";
import Design from "@/server/com/silkplm/model/plm/Design";
import ImageCard from "@/components/forms/renderers/inspirations/ImageCard.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import FileUpload from "@/components/FileUpload.vue";
import FileUploadButton from "@/components/FileUploadButton.vue";
import {sendEvent} from "@/utils/GEvents";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import ListOfImageTag from "@/server/com/silkplm/rpc/plm/ListOfImageTag";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import VBox from "@/components/VBox.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import CloseButton from "@/components/navbar/CloseButton.vue";
import ImageGallery from "@/server/com/silkplm/files/images/ImageGallery";
import ActivityManager from "@/activity/ActivityManager";
import PinturaImageEditor from "@/components/img/PinturaImageEditor.vue";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import FormsActions from "@/components/forms/FormsActions";
import ImageTag from "@/server/com/silkplm/model/plm/dictionaries/ImageTag";
import {generateProductWithThreePoses, sketch2Photo} from "@/components/img/AIService";
import {
  getImageFileFromUrl,
  replacePlaceholderWithImage,
  preparePlaceholder,
  findIndexOfPlaceholder, setImageTag, base64ToFile
} from "@/components/forms/renderers/inspirations/InspirationService";
import RoutingKeys from "@/server/RoutingKeys";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import JsonData from "@/server/com/silkplm/engine/json/JsonData";
import ImageMetadata from "@/server/com/silkplm/rpc/plm/ImageMetadata";

const DESIGN_FORM_TYPE = Design;

export default {
  name: "DesignEditor",
  design_permission: () => FormsLoader.formPermission(DESIGN_FORM_TYPE),
  components: {
    CloseButton, FooterNavbar,
    VBox,
    FileUploadButton,
    FileUpload, FooterButton, ImageCard, ReachInput, FormMixin, FormEditActivity, FormsListActivity
  },

  props: {
    entityId: {default: null},
    inspirationImagesList: {default: null},
    mode: {type: String, default: "NEW"},
    context: {default: null},
    inspirationForm: {default: null},
    inspirationFormConfig: {default: null},
    presetFields: {default: null},
    disableClose: {default: false},
  },

  watch: {

    typeOfProduct(newVal) {
      if (this.typeOfProduct === 'Fashion') {
        this.selectedTechnic = 'With Model #1';
        this.selectedPose = '1 Pose';
      } else {
        this.selectedTechnic = 'Photo Realistic';
      }
    },
  },

  computed: {
    columnClass() {
      return this.typeOfProduct === 'Fashion' ? 'col-6 pr-5' : 'col-12';
    },
    isMobile() {
      return this.isMobileView;
    },
    isFooterButtonDisabled() {
      return (
          !this.input ||
          (this.typeOfAiModel === 'Sketch To Image' && !this.imageSrc) ||
          (!this.selectedTechnic &&
              this.typeOfProduct !== 'Fabric pattern' &&
              this.typeOfAiModel !== 'Sketch To Image') ||
          this.generating ||
          (!this.typeOfProduct && this.typeOfAiModel === 'Text To Image') ||
          (this.typeOfProduct === 'Accessories' &&
              (!this.accessoriesTargetGender || !this.accessories) &&
              this.typeOfAiModel === 'Text To Image')
      );
    }
  },

  async mounted() {
    this.allTagsFromDB = await ImageTag.list();

    this.validatedField = this.form && this.form.validatedFieldsByName.get("gallery");
    this.validatedField.validatedForm.onLoaded(async () => {
      this.localImagesList = this.validatedField._value;
      this.validatedFieldForInspiration = this.inspirationForm && this.inspirationForm.validatedFieldsByName.get("image");
      this.$emit('images-list-changed', this.validatedField._value.imagesList);
    });

    window.addEventListener('resize', this.updateWindowWidth);

    if (this.typeOfProduct === 'Fashion') {
      this.selectedTechnic = 'With Model #1';
      this.selectedPose = '1 Pose';
    } else {
      this.selectedTechnic = 'Photo Realistic';
    }

    this.$subscribe(RoutingKeys.INSPIRATION_IMAGE_LIST_CHANGES + "." + this.entityId, async message => {
      let galleryFromBackend = message.selectedImages;
      let imagesList = galleryFromBackend.imagesList;
      this.$emit('images-list-changed', imagesList);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },

  methods: {
    ...Activity.methods,

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.imageSrc = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.imageSrc = null;
      this.$refs.fileInput.value = null;
    },

    toggleRibbon() {
      this.ribbonOpen = !this.ribbonOpen;
    },
    updateWindowWidth() {
      this.isMobileView = window.innerWidth <= 1050;
      if (!this.isMobileView) {
        this.ribbonOpen = false;
      }
    },

    select() {
      this.setResult({
        image: this.file,
        description: this.input
      })
      this.close();
    },

    getFileName(url) {
      return url.split('/').pop();
    },

    async saveImage(image) {
      if (this.localImagesList == null) {
        this.localImagesList = new ImageGallery();
        this.localImagesList.imagesList = [];
      }

      if (this.validatedField._value == null) {
        this.validatedField._value = new ImageGallery();
      }

      if (this.validatedField._value.imagesList == null) {
        this.validatedField._value.imagesList = [];
      }
      image.metadata = new ImageMetadata();
      let gallery = this.validatedField._value;
      gallery.imagesList = [image, ...gallery.imagesList];
      this.validatedField._value = gallery;
      this.$emit('images-list-changed', this.validatedField._value.imagesList);
      if (this.entityId) {
        await this.validatedField.saveField();
      }
    },

    async imageSelected(files) {
      let imageUpload = this.$refs.imageUpload;
      try {
        for (let file of files) {
          let uploadedImage = await Rpc.BusinessEntities.uploadImage(file, "").lock();
          if (uploadedImage) {
            await this.saveImage(uploadedImage);
          }
        }
        imageUpload.reset();
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          imageUpload.setError(e.fields.image.errorMessage);
        }
      }
    },

    getTitle() {
      return 'AI Photo Generator';
    },

    clickOnButton() {
      this.$emit("download");
    },

    async removeGeneratingTagImages() {
      if (
          !this.validatedField ||
          !this.validatedField._value ||
          !Array.isArray(this.validatedField._value.imagesList)
      ) {
        return;
      }

      let gallery = this.validatedField._value;
      gallery.imagesList = gallery.imagesList.filter(img =>
          !(img.customData &&
              Array.isArray(img.customData.imageTagList) &&
              img.customData.imageTagList.some(tag => tag.name === "Generating"))
      );
      this.validatedField._value = gallery;

      if (this.entityId && this.mode !== "NEW") {
        await this.validatedField.saveField();
      }
    },


    async cancel() {
      await this.removeGeneratingTagImages();
      this.$emit('cancel');
    },

    async draw() {
      try {
        this.image = await Rpc.PaintingTools.createEmptyImage();
        await this.editImage();
      } catch (error) {
        console.error(error);
      }
    },

    async editImage() {
      let result = await (await ActivityManager.showActivity(PinturaImageEditor, {
        image: this.image,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.BusinessEntities.uploadImage(image, "").lock()
      })).getResult();

      if (result) {
        await this.saveImage(result.newFile);
      }
    },

    async handleGenerate() {
      if (this.typeOfAiModel === 'Sketch To Image') {
        await this.onSketch2Photo();
      } else {
        await this.generate();
      }
    },

    prepareImage(newImageFile){
      setImageTag(this.allTagsFromDB, newImageFile, this.typeOfAiModel);
      if(this.typeOfProduct){
        setImageTag(this.allTagsFromDB, newImageFile, this.typeOfProduct);
      }
      if (this.selectedPose) {
        setImageTag(this.allTagsFromDB, newImageFile, this.selectedPose);
      }
      if (this.selectedTechnic) {
        setImageTag(this.allTagsFromDB, newImageFile, this.selectedTechnic);
      }
      let customData = newImageFile.customData;
      if(customData != null) {
        customData.prompt = this.input;
      }else if(newImageFile.customData === null) {
        customData = new ListOfImageTag();
        customData.prompt = this.input;
      }
      newImageFile.customData = customData;
    },

    async replaceImageOnIndex(index, newImageFile) {
      this.prepareImage(newImageFile);
      this.$set(this.validatedField._value.imagesList, index, newImageFile);
      if (this.mode !== "NEW") {
        await this.validatedField.saveField();
      }
    },

    async addAdditionalImages(newImageFile) {
      this.prepareImage(newImageFile);
      await this.saveImage(newImageFile)
    },

    async generate() {
      this.image = await Rpc.PaintingTools.createEmptyImage();
      let placeholder = preparePlaceholder(this.image, this.allTagsFromDB);
      this.nothingFound = false;
      if (this.input.length >= 3) {
        this.noText = false;
        this.generating = true;
        try {
          if(this.selectedPose === "3 Poses"){
            const listOfImagesBase64 = await generateProductWithThreePoses( this.input, {
              onProgress: (progress) => {
                this.progressValue = progress;
              },
              savePlaceholderToGallery: async () => await this.saveImage(placeholder),
            });
            for (let [index, base64] of listOfImagesBase64.entries()) {
              let result = await replacePlaceholderWithImage(base64, this.validatedField);
              if(index === 0){
                await this.replaceImageOnIndex(result[0], result[1]);
              } else {
                let fileObject = base64ToFile(base64);
                const newImageFile = await Rpc.BusinessEntities.uploadImage(fileObject, "").lock()
                if (newImageFile) {
                  await this.addAdditionalImages(newImageFile);
                }
              }
            }
          }else {
            let type = this.typeOfProduct;
            await this.saveImage(placeholder);
            sendEvent("ai-gen-" + type, {});
            let task = await Rpc.ai.GenerateImageByAI.generateProduct(this.selectedTechnic, this.withModel, this.input, this.typeOfProduct, this.aiProps);
            if (type === "Fabric pattern") {
              this.file = await task.finish();
              const index = findIndexOfPlaceholder(this.validatedField);
              if (index !== -1) {
                await this.replaceImageOnIndex(index, this.file)
              }
              this.image = this.file.url;
            } else {
              this.file = await task.finish();
              const index = findIndexOfPlaceholder(this.validatedField);
              if (index !== -1) {
                await this.replaceImageOnIndex(index, this.file)
              }
              this.image = this.file.url;
            }
          }
        } catch (e) {
          this.nothingFound = true;
        } finally {
          this.generating = false;
        }
      } else {
        this.noText = true;
      }
    },

    async onSketch2Photo() {
      try {
        this.image = await Rpc.PaintingTools.createEmptyImage();
        let placeholder = preparePlaceholder(this.image, this.allTagsFromDB);
        this.generating = true;
        const newImageData = await sketch2Photo(this.input,{
          saveImage: () => getImageFileFromUrl(this.imageSrc),
          onProgress: (progress) => {
            this.progressValue = progress;
          },
          savePlaceholderToGallery: async () => await this.saveImage(placeholder),
        });

        let result = await replacePlaceholderWithImage(newImageData, this.validatedField);
        await this.replaceImageOnIndex(result[0], result[1])
      } catch (e) {
        this.nothingFound = true;
      } finally {
        this.generating = false;
      }
    },

    accessoriesRefresh() {
      this.accessories = this.$refs.accessoriesInput.$el.value;
      this.aiProps["type"] = this.accessories;
    },

    accessoriesTargetGenderRefresh() {
      this.accessoriesTargetGender = this.$refs.accessoriesTargetGenderInput.$el.value;
      this.aiProps["gender"] = this.accessoriesTargetGender;
    },

    async canClose() {
      return this.$refs.formEditor.canClose();
    },

    /** @type {FormModel} form */
    async formCreated(form) {
      this.form = form;
      this.form.masterFormModel = this.inspirationForm;
    },

    async createProduct() {

      if (!this.inspirationForm.validatedFieldByName('category').value) {
        await DialogManager.info($tr('inspiration.error.while.create.product.title',
                'Error while adding Inspiration to Project List'),
            $tr('inspiration.error.while.create.product.body', 'Please add a value to the required field - Category'));
        return;
      }

      this.loading = true;
      this.creatingProduct = true;

      ``
      let formConfigProject;
      if (SessionManager.hasFlag(FeatureFlag.SEPARATE_PRODUCT)) {
        formConfigProject = FormsLoader.detectFormConfig(Product.getRemoteClass());
      } else {
        formConfigProject = FormsLoader.detectFormConfig(ProductInSeason.getRemoteClass());
      }

      let gallery = new ImageGallery();
      gallery.imagesList = this.validatedField._value.imagesList;

      let context = {
        ...this.context,
        presetFields: [
          {fieldName: "aiInsight", value: null},
          {
            fieldName: "category",
            value: this.inspirationForm.validatedFieldByName('category').value
          },
          // {fieldName: "fullName", value: this.validatedFieldForInspiration.validatedForm.validatedFieldByName('productName').value},
          {
            fieldName: "name",
            value: this.inspirationForm.validatedFieldByName('name').value
          },
          {
            fieldName: "graphicDesigner",
            value: this.inspirationForm.validatedFieldByName('graphicDesigner').value
          },
          {
            fieldName: "designer",
            value: this.inspirationForm.validatedFieldByName('designer').value
          },
          {
            fieldName: "seasonId",
            value: this.inspirationForm.validatedFieldByName('seasonId').value
          },
          // {fieldName: "productType", value: this.validatedField.validatedForm.validatedFieldByName('types').value},
          {
            fieldName: "notes",
            value: this.inspirationForm.validatedFieldByName('reachDescription').value
          },
          // {fieldName: "pattern", value: this.validatedField.validatedForm.validatedFieldByName('pattern').value},
          {fieldName: "gallery", value: gallery},
          {fieldName: "colorBox", value: true}
        ]
      }
      await this.inspirationForm.saveEntity();
      await FormsActions.create(formConfigProject, context);
      this.loading = false;
      this.creatingProduct = false;

    },

    async saveAndClose() {
      try {
        this.saveInProgress = true;
        if (await this.save()) {
          let closeFormAfterInsertEntity = this.inspirationFormConfig.closeFormAfterInsertEntity;
          if (!closeFormAfterInsertEntity && this.mode === "NEW") {
            let inspirationFormConfig = this.inspirationFormConfig;
            let inspirationId = this.inspirationForm.id;
            this.reopen = async () => {
              setTimeout(async () => {
                    try {
                      if (inspirationId) {
                        await FormsActions.editEntity(inspirationFormConfig, inspirationId);
                      }
                    } finally {
                      ActivityManager.enableFade();
                    }
                  }
              )
            };
          }
          await this.close();
        }
      } finally {
        this.saveInProgress = false;
      }
    },

    async close() {
      await this.removeGeneratingTagImages();

      let res = await ActivityManager.closeTopActivity();
      this.activityClosed?.();
      return res;
    },

    async save() {
      try {
        this.$emit('saved-tab', true);

        this.saveInProgress = true;
        this.inspirationEntityInstance = await this.inspirationForm.saveEntity(false, this.regionCode);
        this.form.fields.inspirationId._value = this.inspirationEntityInstance.id;
        this.designEntityInstance = await this.form.saveEntity(false, this.regionCode);
        this.pendingTranslations = this.inspirationEntityInstance?.__supplement__?.translationInProgress;

        if (this.inspirationEntityInstance.__supplement__ || this.designEntityInstance.__supplement__) {
          this.inspirationEntityInstance.__supplement__.translationInProgress = true;
          this.designEntityInstance.__supplement__.translationInProgress = true;
        }

        if (!this.inspirationForm.isValid || this.inspirationForm.temporaryListsErrors ||
            !this.form.isValid || this.form.temporaryListsErrors) {
          setTimeout(() => {
            this.$emit("unsaved-changes");
          });
          DialogManager.infoHtml($tr('saveFailed', 'Save failed'),
              $tr('entityEditForm.records.arent.save', 'Some records aren\'t save successfully, fix or delete broken records')).then();
          return false;
        }

        this.inspirationForm.setFieldsReadOnly(true, this.mode, this.fieldsManagedByParent);
        this.form.setFieldsReadOnly(true, this.mode, this.fieldsManagedByParent);
        this.$emit('saved', this.designEntityInstance);
        this.$emit('saved', this.inspirationEntityInstance);

        return true;
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          let errorSummary = "";
          for (let fieldName in e.fields) {
            let field = e.fields[fieldName];
            if (field['errorMessage']) {
              errorSummary += field['errorMessage'] + "\n";
            }
          }
          if (e.errorMessage) {
            errorSummary += e.errorMessage;
          }

          await DialogManager.infoHtml($tr("entityEditForm.record.cant.save", "Record can't be saved"), errorSummary);
        } else {
          console.log(e);
        }
        return false;
      } finally {
        this.saveInProgress = false;
      }
    },
  },

  data: function () {
    return {
      /** @type {FormModel} */
      DESIGN_FORM_TYPE,
      imageSrc: null,
      localImagesList: null,
      validatedField: null,
      inspirationImage: null,
      ribbonOpen: false,
      isMobileView: window.innerWidth <= 1050,
      form: null,
      saveInProgress: false,
      SAVE_AND_CLOSE_LABEL: $tr("Save", "Save"),
      ADD_AND_CLOSE_LABEL: $tr("add", "Add"),
      permissions: new PermissionsSet(),
      inspirationEntityInstance: null,
      designEntityInstance: null,
      pendingTranslations: false,
      galleryList: [],
      allTagsFromDB: [],
      readOnly: true,
      designId: null,
      designFormConfig: FormsLoader.detectFormConfig(DESIGN_FORM_TYPE),
      designFormId: FormsLoader.detectFormConfig(DESIGN_FORM_TYPE).formId,
      image: null,
      file: null,
      accessories: "",
      accessoriesTargetGender: "",
      accessoriesOptions: ["bag", "shoes", "necklace", "bracelet", "earrings", "watch", "ring", "sunglasses"],
      genderOptions: ["man", "woman"],
      aiProps: {},
      customStyleForFluidContainer: "height: auto !important;",
      typeOfAiModel: 'Text To Image',
      aiModelsOptions: [
        {
          text: $tr('ai-inspiration-generator-text-to-image', 'Text To Image'),
          value: 'Text To Image',
          click: (value) => {
            this.typeOfAiModel = value;
            this.selectedTechnic = null;
            this.selectedPose = null;
            this.typeOfProduct = null;
            this.input = "";
          }
        },
        {
          text: $tr('ai-inspiration-generator-draw-from-scratch', 'Draw From Scratch'),
          value: 'Draw From Scratch',
          click: this.draw
        },
        {
          text: $tr('ai-inspiration-generator-sketch-to-image', 'Sketch To Image'),
          value: 'Sketch To Image',
          click: (value) => {
            this.typeOfAiModel = value;
            this.selectedTechnic = null;
            this.typeOfProduct = null;
            this.selectedPose = null;
            this.input = "";
          }
        },
      ],
      typeOfProduct: 'Fashion',
      productOptions: [
        {text: $tr('ai-product-generator-fashion', 'Fashion'),
          value: 'Fashion',
          click: (value) =>{
            this.typeOfProduct = value;
            this.selectedPose = null;
            this.selectedTechnic = null;
            this.input = "";
          }
        },
        {text: $tr('ai-product-generator-home-decor', 'Home Decor'),
          value: 'Home Decor',
          click: (value) =>{
            this.typeOfProduct = value;
            this.selectedPose = null;
            this.selectedTechnic = null;
            this.input = "";
          }},
        {text: $tr('ai-product-generator-pattern', 'Fabric Pattern'),
          value: 'Fabric pattern',
          click: (value) =>{
            this.typeOfProduct = value;
            this.selectedPose = null;
            this.selectedTechnic = null;
            this.input = "";
          }},
        {text: $tr('ai-product-generator-accessories', 'Accessories'),
          value: 'Accessories',
          click: (value) =>{
            this.typeOfProduct = value;
            this.selectedPose = null;
            this.selectedTechnic = null;
            this.input = "";
          }},
      ],
      noImg: 'https://silkplm.com/wp-content/uploads/2025/01/placeholder-image.png',
      selectedTechnic: '',
      technicOptions: [
        {text: $tr('technic-sketch', 'Sketch'), value: 'Sketch'},
        {text: $tr('technic-colored-sketch', 'Colored Sketch'), value: 'Colored Sketch'},
        {text: $tr('technic-photo-realistic', 'Photo Realistic'), value: 'Photo Realistic'},
      ],
      selectedPose: '1 Pose',
      fashionPosesOptions: [
        {text: $tr('fashion-pose-1', '1 Pose'), value: '1 Pose'},
        {text: $tr('fashion-poses-3', '3 Poses'), value: '3 Poses'},
      ],
      withModel: false,
      input: '',
      generating: false,
      noText: false,
      nothingFound: false,
    }
  }
}
</script>

<style>
.custom-container {
  overflow: auto;
  position: absolute;
  top: 40px;
  right: 0;
  bottom: 0;
  left: 0;
}

.custom-col {
  overflow: auto;
  position: absolute;
  top: 0;
  bottom: 55px;
  left: 0;
}

.custom-col-right {
  right: 0;
  margin-top: 0;
  margin-left: 25rem;
}

.custom-col-left {
  background-color: white;
  width: 26rem;
}

.custom-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}

.ribbon-toggle-container {
  width: 100%;
  height: 55px;
  background-color: #f8f9fa;
  position: fixed;
  top: 40px;
}

.ribbon-toggle-button {
  position: fixed;
  left: 8px;
  margin-top: 10px;
  padding: 6px 12px;
  z-index: 1001;
  cursor: pointer;
}

@media screen and (max-width: 1050px) {
  .custom-col-right {
    margin-top: 35px;
    margin-left: 0;
  }

  .custom-col-left {
    margin-top: 50px;
  }

  .custom-col-left.ribbon {
    display: block;
    transform: translateX(0);
    transition: transform 0.3s ease-in-out;
  }

  .custom-col-left.ribbon.ribbon-hidden {
    transform: translateX(-100%);
  }
}

.custom-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}

.checkbox-group .btn {
  border-radius: 5px;
  background-color: #4D7A98;
  padding: 10px 20px;
}

.checkbox-group .btn:hover {
  background-color: #253D5A;
}

.checkbox-group .btn.btn-secondary.active {
  background-color: #253D5A;
}

.selected-btn {
  background-color: #4D7A98;
}

.selected-btn:hover {
  background-color: #253D5A;
}

.unselected-btn {
  background-color: #253D5A;
}

.unselected-btn:hover {
  background-color: #253D5A;
}

.custom-button {
  color: #4D7A98;
  font-weight: bold;
  background-color: transparent;
  border-radius: 5px;
  border: 2px solid #4D7A98 !important;
}

.custom-button:hover {
  color: #FFFFFF;
  background-color: #4D7A98;
}

.upload-box {
  border: 2px dashed #ccc;
  text-align: center;
  cursor: pointer;
  width: 300px;
  height: 400px;
  max-height: 400px;
  min-height: 400px;
  max-width: 300px;
  min-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}

.no-border {
  border: none;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  max-height: 400px;
  min-height: 400px;
  max-width: 300px;
  min-width: 300px;
}

.clear-btn {
  position: absolute;
  top: 15px;
  right: 60px;
  cursor: pointer;
  background-color: #FFFFFF !important;
  border-radius: 4px !important;
}

.custom-radio-group label {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>